import Axios, { AxiosResponse } from "axios";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";

export type VisitorBookingsMode = "active" | "archive";

/** Admin visitor list for active/upcoming or archive/past bookings. */
export const fetchVisitorBookingSchedules = (
  mode: VisitorBookingsMode
): Promise<AxiosResponse<BookingScheduleInterface[]>> => {
  return Axios.get<BookingScheduleInterface[]>(`/booking-schedule/visitor/${mode}`);
};
